import { render, staticRenderFns } from "./device026-f-dimming3.vue?vue&type=template&id=56e649a7&"
import script from "./device026-f-dimming3.vue?vue&type=script&lang=js&"
export * from "./device026-f-dimming3.vue?vue&type=script&lang=js&"
import style0 from "./device026-f-dimming3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports